import React from 'react';
import { useSite } from '@/context/SiteContext';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { SectionHeading, Reveal } from './Motion';

/**
 * Editable FAQ (Admin -> Settings -> SEO). Rendered as real text (not only schema) so the FAQPage
 * structured data on the Home page always matches visible content.
 */
export const FaqSection = ({ compact = false, title = 'Good to know', label = 'Questions guests ask' }) => {
  const { site } = useSite();
  const faqs = (site?.settings?.faqs || []).filter((f) => f?.question && f?.answer);
  if (!faqs.length) return null;
  return (
    <section className={compact ? 'py-12 sm:py-16' : 'section-y'} data-testid="faq-section" id="faq">
      <div className="container-x grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <SectionHeading label={label} title={title} />
        </div>
        <Reveal className="md:col-span-8" delay={0.1}>
          <Accordion type="single" collapsible className="border-t border-border" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={`${i}-${f.question}`} value={`faq-${i}`} className="border-b border-border" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="py-5 text-left font-display text-lg sm:text-xl font-normal hover:no-underline hover:text-[hsl(var(--brand-teal))] [&[data-state=open]]:text-[hsl(var(--brand-teal))]" data-testid={`faq-question-${i}`}>
                  <h3 className="font-display text-lg sm:text-xl font-normal">{f.question}</h3>
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-[15px] leading-[1.85] text-foreground/75 max-w-prose whitespace-pre-line" data-testid={`faq-answer-${i}`}>
                  {f.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
